import useRankingTable from '../../../hooks/useRankingTable';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    name: 'Ranking',
    isStatic: false
  },
  exposure_as_percentage_of_nav: {
    name: 'Exposure as % of NAV',
    isStatic: false
  },
  counterparty_bic: {
    name: "Counterparty's BIC",
    isStatic: false
  },
  counterparty_lei: {
    isStatic: false,
    name: "Counterparty's LEI"
  },
  counterparty_name: {
    name: "Counterparty's name",
    isStatic: false
  },
  counterparty_exposure_flag: {
    isStatic: false,
    name: 'Counterparty exposure flag',
    withoutLetter: true
  }
};

export function CountriesCPP({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.TOP_FIVE_COUNTRIES_EXPOSURE_EXCLUDE_CCP,
    onChangeFund,
    schema: schema.TOP_FIVE_COUNTRIES_EXPOSURE_EXCLUDE_CCP,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.TOP_FIVE_COUNTRIES_EXPOSURE_EXCLUDE_CCP
        ?.field_names || [],
    columnLables,
    order: 193,
    isMultiFunds,
    funds,
    tableName: 'TOP_FIVE_COUNTRIES_EXPOSURE_EXCLUDE_CCP'
  });

  return (
    <StyledTables id="fca-reporttables-countries-cpp-group">
      {tables.map((rows, index) => (
        <Table
          id={`fca-reporttables-countries-cpp-table-${index + 1}`}
          key={index + 'TOP_FIVE_COUNTRIES_EXPOSURE_EXCLUDE_CCP'}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
        />
      ))}
    </StyledTables>
  );
}
